import { useMe } from './use-me';

// The Users tab shows for any admin (org-admin OR super-admin). Now derived from
// GET /me (no 403 probe) — see use-me.js. /me additionally distinguishes
// super-admins (me.isSuperAdmin), used to gate the org-edit modal in UsersPanel.
export function useIsAdmin() {
  const { me } = useMe();
  return !!me?.isAdmin;
}
